import React from 'react';
import ContactSection from '../components/ContactSection';
import Footer from '../components/Footer';

const ContactPage: React.FC = () => {
  return (
    <>
      <main className="min-vh-100">
        <div className="container py-4 py-md-5 px-3 px-md-0">
          <div className="row justify-content-center mb-4">
            <div className="col-lg-8 text-center">
              <span className="section-eyebrow">Contact</span>
              <h1 className="section-title mt-2">Get in Touch with BMCS</h1>
              <p className="lead text-muted">
                We’d love to hear from you! Whether you have questions, want to join our community, or need more information, we’re here to help.
              </p>
            </div>
          </div>
        </div>
        <ContactSection compact />
      </main>
      <Footer />
    </>
  );
};

export default ContactPage;
